<div class="center-screen">
  <img class="bigger-icon" src="/assets/img/Error.svg"/>
  <h3 class="text-center display-3">The page you are looking for can't be found, sorry about that!</h3>
</div>
